import styled, { css } from 'styled-components';

export const Container = styled.article`
  background: #f5f5f5;
  width: 100%;
  position: relative;
  display: inline-flex;

  &[role='button'] {
    cursor: pointer;

    img {
      transition: transform 0.3s;
    }

    &:hover img:not(.momento-inside) {
      transform: scale(1.3);
      /* animation: focus 10s infinite ease; */
    }
  }
`;

export const Summary = styled.div`
  position: relative;
  width: 100%;

  @media screen and (min-width: 1025px) {
    ${({ isModal }) =>
      isModal &&
      css`
        width: 50%;
      `}
  }
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  & > img {
    width: 100%;
    margin-bottom: -6px;

    &.momento-inside {
      width: 80px !important;
      height: 80px;
      position: absolute;
      top: 20px;
      left: 20px;
    }
  }
`;

export const ModalContainer = styled(Container)`
  width: 100%;
  max-width: 502px;
  /* z-index: 100; */
  /* max-width: calc(100vw - 32px); */
  background: white;
  margin: 0;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 1025px) {
    width: 1024px;
    max-width: 100%;
    flex-direction: row;
  }

  .summary img {
    width: 100%;
  }
`;

export const Details = styled.div`
  background: white;
  flex: 1;
  padding: 1rem 0 0;
  display: flex;
  flex-direction: column;
  /* height: 244.22px; */
  overflow: hidden;

  @media screen and (min-width: 1025px) {
    padding: 0 1rem;
  }

  p,
  h3,
  h4 {
    margin: 0;
    &.description {
      min-height: 25px;
      height: 100%;
      white-space: pre-wrap;
    }
  }

  small {
    font-size: 11px;
  }
  table {
    width: 100%;
  }

  select {
    font-size: 13px;
    padding: 3px;
  }

  input {
    color: #666;
    border-radius: 40px;
    height: 40px;
    padding: 0 0 0 15px;
    border: 1px solid #666;
    text-align: center;
    width: 120px;
  }

  textarea {
    padding: 4px 8px;
    font-size: 14px;
    border-radius: 6px;
    width: 100%;
    resize: none;
  }
`;

export const Price = styled.span`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-weight: bold;
  cursor: default;
`;

export const Box = styled.div`
  width: 100%;
  padding: 14px 0 0;
  position: relative;

  small {
    font-size: 10px;
    line-height: 10px;
    font-weight: bold;
    vertical-align: super;
    position: absolute;
    top: 0.1rem;
    left: 0;
  }

  h3 {
    /* margin: 0.75rem 0; */
    text-align: center;
  }
  h4 {
    height: 25px;
  }
  select {
    height: 25px;
    width: 100%;
  }

  &.price-box {
    border: 1px solid currentColor;
    padding: 1rem 0;

    small {
      top: 0.2rem;
      left: 0.2rem;
      font-size: 8px;
      line-height: 8px;
    }
  }

  &.total {
    color: var(--color-primary);
  }
`;

export const TitleContainer = styled.div``;

export const Title = styled.p`
  margin: 0;
  font-weight: bold;
  text-transform: uppercase;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  padding-bottom: 6px;
`;

export const Subtitle = styled.p`
  margin: 0;
  font-weight: bold;
  font-size: 0.8rem;
  font-style: italic;
`;

export const SummaryTitleContainer = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-weight: bold;
  cursor: default;
  max-width: 98%;
  p {
    zoom: 0.8;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0.35rem 0;

  .number-input {
    width: 160px;
    button {
      width: 32px !important;
      padding: 0;
    }
  }
`;

export const Col = styled.div`
  flex: 1;
  margin: 0 0.25rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`;

export const Button = styled.button`
  display: block;
  width: 100%;
  color: #666;
  font-weight: bold;
  border: 1px solid #666;
  cursor: pointer;
  background: white;
  border-radius: 50px;
  height: 40px;
  position: relative;

  &:hover {
    background: var(--color-gray2);
  }

  &:active {
    background: var(--color-primary);
    color: var(--color-white);
  }

  span.badge {
    position: absolute;
    top: -10px;
    margin-left: -5px;
  }
`;

export const HidePrice = styled.h3`
  filter: blur(4px);
`;
